module.exports = __webpack_public_path__ + "static/media/ic_show.27180b61.svg";